import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DownloadIcon from '@mui/icons-material/Download';
import SectionTitle from '../shared/SectionTitle';
import InfoCard from '../shared/InfoCard';
import { t } from '../../../../utils/textUtils';
import { DETAIL_GRID_SX } from '../utils/constants';

const WorkPlanTab = ({ project }) => (
  <>
    <SectionTitle
      title={t('RENCANA KERJA & VOLUME')}
      subtitle={t('Detail volume pekerjaan dan spesifikasi bangunan.')}
    />

    <Box sx={DETAIL_GRID_SX}>
      <InfoCard
        label={t('JUMLAH UNIT BANGUNAN (LEVEL 2)')}
        value={project.jumlahUnitModular || project.jumlahUnitBangunan || t('TIDAK DITENTUKAN')}
        icon={<HomeWorkIcon sx={{ color: '#22C55E' }} />}
      />
      <InfoCard
        label={t('TIPE PREFABRIKASI')}
        value={project.tipePrefabrikasi || project.tipeBangunan || t('TIDAK DITENTUKAN')}
        icon={<HomeWorkIcon sx={{ color: '#F59E0B' }} />}
      />
      <InfoCard
        label={t('TOTAL LUAS LAHAN')}
        value={project.luasTotalLahan ? `${project.luasTotalLahan} m²` : t('TIDAK DITENTUKAN')}
        icon={<SquareFootIcon sx={{ color: '#0EA5E9' }} />}
      />
      <InfoCard
        label={t('TOTAL LUAS BANGUNAN')}
        value={project.luasTotalBangunan ? `${project.luasTotalBangunan} m²` : t('TIDAK DITENTUKAN')}
        icon={<SquareFootIcon sx={{ color: '#0EA5E9' }} />}
      />
      <InfoCard label={t('LAYOUT DESAIN')} icon={<PictureAsPdfIcon sx={{ color: '#EF4444' }} />}>
        {project.layoutDesainUrl ? (
          <Button
            variant="outlined"
            size="small"
            startIcon={<DownloadIcon />}
            onClick={() => window.open(project.layoutDesainUrl, '_blank')}
            sx={{ mt: 0.5 }}
          >
            {t('UNDUH FILE')}
          </Button>
        ) : (
          <Typography variant="body1" sx={{ fontWeight: 600 }}>
            {t('TIDAK ADA FILE')}
          </Typography>
        )}
      </InfoCard>
    </Box>
  </>
);

export default WorkPlanTab;
